import { Asistencia } from './asistencia';
import { MesAnterior } from './mes-anterior';
import { Facturacion } from './facturacion';
import { Poliza } from './poliza';
import { SeisMeses } from './seis-meses';
import { UltUbicacion } from './ultima-ubicacion';

export class Seguro{
  poliza: Poliza;
  facturacion: Facturacion;
  mesAnterior: MesAnterior;
  seisMeses: SeisMeses;
  ultimaUbicacion: UltUbicacion;
  asistencias: Asistencia[];
}

